import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { getDisplayName } from '../utils/components';
import { ListItemWrapper } from './list-item-wrapper';
function withListItemWrapper() {
  var mapProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return function (WrappedComponent) {
    // Destructure it to avoid passing these props to WrappedComponent and cause undesired behaviors
    function WithLisItemWrapperComponent(_ref) {
      var focused = _ref.focused,
        onMouseOver = _ref.onMouseOver,
        props = _objectWithoutProperties(_ref, ["focused", "onMouseOver"]);
      var _props$mapProps = _objectSpread(_objectSpread({}, props), mapProps(props)),
        selected = _props$mapProps.selected,
        disabled = _props$mapProps.disabled,
        size = _props$mapProps.size,
        wrapperClassName = _props$mapProps.wrapperClassName,
        wrapperAs = _props$mapProps.wrapperAs;
      return /*#__PURE__*/React.createElement(ListItemWrapper, {
        as: wrapperAs,
        className: wrapperClassName,
        disabled: disabled,
        size: size,
        selected: selected,
        focused: focused,
        onMouseOver: onMouseOver
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    }
    WithLisItemWrapperComponent.displayName = "WithLisItemWrapperComponent(".concat(getDisplayName(WrappedComponent), ")");
    var _ref2 = ListItemWrapper.propTypes || {},
      _ = _ref2.as,
      __ = _ref2.className,
      children = _ref2.children,
      listItemWrapperPropTypes = _objectWithoutProperties(_ref2, ["as", "className", "children"]); // @TODO: fix after we find out the root of undefined proptypes on ninja
    WithLisItemWrapperComponent.SIZES = ListItemWrapper.SIZES;
    return WithLisItemWrapperComponent;
  };
}
export default withListItemWrapper;